'use client'

import { openCookieSettings } from './index'

export function CookieSettingsButton({ className }: { className?: string }) {
  return (
    <button type="button" onClick={openCookieSettings} className={className}>
      Ustawienia cookies
    </button>
  )
}
